var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    [
      _c(
        "section-title",
        { attrs: { icon: "mdi-file-table-outline" } },
        [
          _c(
            "v-row",
            { attrs: { "no-gutters": "", align: "center" } },
            [
              _c("div", [_vm._v("REPORTES")]),
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  staticClass: "hidden-sm-and-down ma-2",
                  attrs: { color: "green", dark: "" },
                  on: {
                    click: function($event) {
                      return _vm.$refs.modal.open()
                    }
                  }
                },
                [_vm._v("DESCARGAR REPORTES")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c("download-report-modal", { ref: "modal" }),
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            [
              _c("v-text-field", {
                attrs: {
                  "append-icon": "mdi-magnify",
                  label: "Buscar",
                  "single-line": "",
                  "hide-details": ""
                },
                model: {
                  value: _vm.searchReports,
                  callback: function($$v) {
                    _vm.searchReports = $$v
                  },
                  expression: "searchReports"
                }
              })
            ],
            1
          ),
          _c("v-data-table", {
            staticClass: "elevation-1",
            attrs: {
              headers: _vm.headersReports,
              search: _vm.searchReports,
              options: _vm.reportsOptions,
              "items-per-page": _vm.itemsPerPageReports[3],
              "items-per-page-options": _vm.itemsPerPageReports,
              items: _vm.reports,
              "footer-props": {
                itemsPerPageOptions: _vm.itemsPerPageReports,
                itemsPerPageText: "Cantidad de reportes por página",
                prevIcon: "",
                nextIcon: "",
                pageText: ""
              },
              loading: _vm.isFetchingReports,
              "loading-text":
                "Obteniendo los reportes, espere un momento por favor"
            },
            on: {
              "update:options": function($event) {
                _vm.reportsOptions = $event
              }
            },
            scopedSlots: _vm._u([
              {
                key: "no-data",
                fn: function() {
                  return [_vm._v(" No hay reportes registrados ")]
                },
                proxy: true
              }
            ])
          }),
          _c(
            "div",
            { staticClass: "grey lighten-4 ma-0 py-2" },
            [
              _c("v-pagination", {
                attrs: {
                  length: _vm.historyOptions.reports.pages,
                  "total-visible": 7
                },
                on: {
                  input: function($event) {
                    return _vm.changePageReportsDayco()
                  }
                },
                model: {
                  value: _vm.pageReports,
                  callback: function($$v) {
                    _vm.pageReports = $$v
                  },
                  expression: "pageReports"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }